/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateNicknameBody
 */
export interface UpdateNicknameBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateNicknameBody
     */
    nickname: string;
}

/**
 * Check if a given object implements the UpdateNicknameBody interface.
 */
export function instanceOfUpdateNicknameBody(value: object): value is UpdateNicknameBody {
    if (!('nickname' in value) || value['nickname'] === undefined) return false;
    return true;
}

export function UpdateNicknameBodyFromJSON(json: any): UpdateNicknameBody {
    return UpdateNicknameBodyFromJSONTyped(json, false);
}

export function UpdateNicknameBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNicknameBody {
    if (json == null) {
        return json;
    }
    return {
        
        'nickname': json['nickname'],
    };
}

export function UpdateNicknameBodyToJSON(json: any): UpdateNicknameBody {
    return UpdateNicknameBodyToJSONTyped(json, false);
}

export function UpdateNicknameBodyToJSONTyped(value?: UpdateNicknameBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nickname': value['nickname'],
    };
}

